import React from 'react';
import { Button, Card, Col, Row, Table, Tag, Tooltip as AntdTooltip } from 'antd';
import { DownloadOutlined, FilterOutlined } from '@ant-design/icons';
import { DISPLAY_DATE_FORMAT, VIEW_MODE } from './LifeCycleAnalyticsConstants';
import { EmptyState } from '../empty_state/EmptyState';

const PrioritySummaryCard = ({
	loading,
	totalCompletedWorkOrders,
	prioritySummaryCards,
	tableDataSource,
	expandedDropdownData,
	priorityTableColumns,
	viewMode,
	hasActiveFilters,
	activeFilters,
	problemTypeNames,
	handleArrowClick,
	handleRowClick,
	openFilterModal,
	exportPrioritySummaryCsv,
	removeProblemTypeFilter,
	handleRemoveCreatedAtFilter,
	handleRemoveCompletedAtFilter,
}) => {
	return (
		<Row gutter={12} className="-mx-1.5 my-3">
			<Col span={24}>
				<Card className="lifeCycleSummaryCard">
					<div className="flex h-8 w-full items-center justify-between">
						<div className="flex h-8 items-center gap-2">
							<div className="h4medium">Completed Work Orders: {totalCompletedWorkOrders}</div>
							<Button icon={<FilterOutlined />} onClick={openFilterModal} />
						</div>
						<Button icon={<DownloadOutlined />} onClick={exportPrioritySummaryCsv} />
					</div>
					{hasActiveFilters && (
						<div className="mb-4 mt-2.5">
							{activeFilters.problemTypeIds.length > 0 && (
								<Tag closable onClose={removeProblemTypeFilter}>
									Problem Type:{' '}
									{problemTypeNames || `${activeFilters.problemTypeIds.length} selected`}
								</Tag>
							)}
							{activeFilters.createdAt && activeFilters.createdAt[0] && activeFilters.createdAt[1] && (
								<Tag closable onClose={handleRemoveCreatedAtFilter}>
									Created between: {activeFilters.createdAt[0].format(DISPLAY_DATE_FORMAT)} to{' '}
									{activeFilters.createdAt[1].format(DISPLAY_DATE_FORMAT)}
								</Tag>
							)}
							{activeFilters.completedAt &&
								activeFilters.completedAt[0] &&
								activeFilters.completedAt[1] && (
									<Tag closable onClose={handleRemoveCompletedAtFilter}>
										Completed between: {activeFilters.completedAt[0].format(DISPLAY_DATE_FORMAT)} to{' '}
										{activeFilters.completedAt[1].format(DISPLAY_DATE_FORMAT)}
									</Tag>
								)}
						</div>
					)}
					{!loading && totalCompletedWorkOrders === 0 ? (
						<EmptyState
							height={200}
							headline={'No completed work orders found'}
							body={
								<div className="max-w-[488px] text-center">
									There are no completed work orders for the selected filters. Try adjusting your
									filters or expanding the date range.
								</div>
							}
						/>
					) : (
						<>
							<div className="my-3 flex h-[25px] w-full gap-0.5 overflow-hidden rounded-[5px] bg-priority-bar-track">
								{prioritySummaryCards.map((item, index) => (
									<AntdTooltip
										key={item.woPriorityId}
										overlayClassName="lifeCycleProgressTooltip"
										title={
											<div>
												<span
													className="inline-block whitespace-nowrap rounded-2xl px-3 py-1 align-middle text-sm font-medium leading-[22px]"
													style={{
														color: item.color,
														backgroundColor: item.bgColor,
													}}
												>
													{item.woPriorityName}
												</span>
												<div className="mt-1.5 whitespace-nowrap text-sm text-black/65">
													<strong className="text-black/85">{item.completedWoCount}</strong>{' '}
													Completed Work Orders
												</div>
											</div>
										}
									>
										<div
											style={{
												width:
													index === 0
														? `calc(${item.share}% - ${prioritySummaryCards.length * 2}px)`
														: `${item.share}%`,
												border: `1px solid ${item.color}`,
												backgroundColor: item.bgColor,
												cursor: 'pointer',
												borderTopLeftRadius: index === 0 ? '5px' : '0',
												borderBottomLeftRadius: index === 0 ? '5px' : '0',
												borderTopRightRadius:
													index === prioritySummaryCards.length - 1 ? '5px' : '0',
												borderBottomRightRadius:
													index === prioritySummaryCards.length - 1 ? '5px' : '0',
											}}
											className="h-full min-w-1 shrink-0"
											onClick={() => handleArrowClick(item.woPriorityId)}
										/>
									</AntdTooltip>
								))}
							</div>
							<div className="lifeCyclePriorityTable">
								<Table
									columns={priorityTableColumns}
									dataSource={tableDataSource}
									pagination={false}
									size="small"
									tableLayout="fixed"
									rowKey={(row) => `${row.woPriorityId}`}
									onRow={handleRowClick}
								/>
								{viewMode === VIEW_MODE.EXPANDED && expandedDropdownData.length > 0 && (
									<div className="lifeCyclePriorityDropdown">
										<Table
											columns={priorityTableColumns}
											dataSource={expandedDropdownData}
											pagination={false}
											size="small"
											showHeader={false}
											tableLayout="fixed"
											rowKey={(row) => `${row.woPriorityId}`}
											onRow={handleRowClick}
										/>
									</div>
								)}
							</div>
						</>
					)}
				</Card>
			</Col>
			{viewMode === VIEW_MODE.ALL && (
				<Col span={24} className="bodyregular px-4 py-3 text-center text-character-secondary">
					Changes shown are measured against previous period
				</Col>
			)}
		</Row>
	);
};

export default PrioritySummaryCard;
